<template>
    <investor-adviser-selector
        v-if="modalKey === 'INVESTOR_ADVISER_SELECTOR'"
        v-model="modalActive"
        :investor-id="modalProps.investor_id"
        :heading="modalProps.heading"
        :text="modalProps.text"
        :submit-button-text="modalProps.submitButtonText"
        :multiple="modalProps.multiple"
        :get-item-text="modalProps.getItemText"
        @submit="modalCallback"
    />
</template>

<script>
const APP_PLATFORM_MODAL = ['INVESTOR_ADVISER_SELECTOR'];

export default {
    name: 'AppPlatformModal',
    components: {
        InvestorAdviserSelector: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/modals/InvestorAdviserSelector'
            )
    },
    computed: {
        modal() {
            return this.$store.getters['app/modal'];
        },
        modalActive: {
            get() {
                return this.modal && this.modal.active;
            },
            set(value) {
                if (!value) {
                    this.$store.dispatch('app/resetModal', value);
                }
            }
        },
        modalKey() {
            if (!this.modal || !this.modal.active) {
                return null;
            }

            const key = this.modal.key;

            if (!APP_PLATFORM_MODAL.includes(key)) {
                throw new Error(`Invalid modal key: ${key}`);
            }

            return key;
        },
        modalProps() {
            if (!this.modal || !this.modal.active) {
                return null;
            }

            return this.modal.props || {};
        },
        modalCallback() {
            if (!this.modal) {
                return () => {};
            }

            return this.modal.callback;
        }
    }
};
</script>
